/* lua.js generated code 0.3.0 */

var Event = require("cocos/framework/components/event")
var UserLevelUtil = require("clover/logic/userLevel/UserLevelUtil")
UserScore = xClass("UserScore", Event)
UserScoreEvent = table(
    [1, "UpdateScore", "USERSCOREEVENT.UPDATESCORE"],
    [1, "NewLevel", "USERSCOREEVENT.NEWLEVEL"],
    [1, "NewRecord", "USERSCOREEVENT.NEWRECORD"],
    [1, "NewStar", "USERSCOREEVENT.NEWSTAR"],
    [1, "NewTopLevelTemp", "USERSCOREEVENT.NEWTOPLEVELTEMP"],
    [1, "NewHideSuccessLevel", "USERSCOREEVENT.NEWHIDESUCCESSLEVEL"]
)
var instance = null
UserScore.getInstance = function () {
    if (!instance) {
        instance = UserScore.new()
    }
    return instance
}
UserScore.prototype.ctor = function () {
    var self = this
    self.bind(self)
}
UserScore.prototype.updateScore = function (levelId, score, star) {
    var self = this
    var scoreRef = UserManager.getInstance().getUserScore(levelId)
    var oldScore = clone(scoreRef) || ScoreRef.create()
    self.setLastScoreBeforeUpdate(oldScore.score);
    var [newLevel, newRecord, newStar] = [false, false, false]
    if (!scoreRef) {
        scoreRef = self.createScore(levelId, star > 0 && score || 0, star)
        UserManager.getInstance().addUserScore(scoreRef)
        // [newLevel, newRecord, newStar] = [true, score > 0, star > 0]
        newLevel = true
        newRecord = score > 0
        newStar = star > 0
    } else {
        newRecord = scoreRef.score < score
        newStar = scoreRef.star < star
        scoreRef.score = Math.max(scoreRef.score, star > 0 && score || 0)
        scoreRef.star = Math.max(scoreRef.star, star)
        if (newRecord || newStar) {
            scoreRef.updateTime = Localhost.time()
        }
        UserManager.getInstance().updateUserScore(levelId)
    }
    self.dispatchEvent(table(
        [1, "name", UserScoreEvent.UpdateScore],
        [1, "levelId", levelId],
        [1, "score", scoreRef],
        [1, "oldScore", oldScore]
    ))
    if (newLevel) {
        self.dispatchEvent(table(
            [1, "name", UserScoreEvent.NewLevel],
            [1, "levelId", levelId],
            [1, "score", scoreRef],
            [1, "oldScore", oldScore]
        ))
    }
    if (newRecord) {
        self.dispatchEvent(table(
            [1, "name", UserScoreEvent.NewRecord],
            [1, "levelId", levelId],
            [1, "score", scoreRef],
            [1, "oldScore", oldScore]
        ))
    }
    if (newStar) {
        UserManager.getInstance().getUserRef().setStarUpdateTime(Localhost.time())
        self.dispatchEvent(table(
            [1, "name", UserScoreEvent.NewStar],
            [1, "levelId", levelId],
            [1, "score", scoreRef],
            [1, "oldScore", oldScore]
        ))
    }
    // FIXME: multi result
    return [scoreRef, oldScore]
}
UserScore.prototype.getLastNotReachTargetStarLevel = function (target) {
    var scores = UserManager.getInstance().scores
    for (var i = 1, v = scores[1]; v; i++, v = scores[i]) {
        if (v.star < target) {
            return v.levelId
        }
    }
    return UserManager.getInstance().user.topLevelId
}
UserScore.prototype.getScore = UserScore.getScore = function (levelId) {
    var score = UserManager.getInstance().getUserScore(levelId)
    return score || ScoreRef.create()
}
UserScore.prototype.hasScore = function (levelId) {
    return UserManager.getInstance().getUserScore(levelId)
}
// 是否需要补星
UserScore.prototype.isNeedComplementStar = function (levelId) {
    let cur_star = this.getScore(levelId).star || 0
    let digest = LevelConfigManager.getInstance().getLevelDigest(levelId)
    let starMax = $len((digest && digest.scoreTargets || table())) || 3
    cc.log("UserScore.prototype.isNeedComplementStar ",cur_star,starMax)
    return cur_star > 0 && cur_star < starMax
}

UserScore.prototype.createScore = function (levelId, score, star) {
    // WARN: maybe multi result
    return ScoreRef.create().fromLua(table(
        [1, "uid", UserManager.getInstance().getUserRef().uid],
        [1, "levelId", levelId],
        [1, "score", score],
        [1, "star", star],
        [1, "updateTime", Localhost.time()]
    ))
}
UserScore.prototype.checkLevelScoreUpdate = function (levelId) {
    var self = this
    var oldScore = clone(UserManager.getInstance().getUserScore(levelId))
    if (!oldScore || oldScore.star < 1) {
        return false
    }
    var score = UserLevelUtil.recalcLevelScore(levelId)
    if (!score || !oldScore) {
        return false
    }
    // 最高加到3星
    score.star = Math.min(score.star, 3)
    if (oldScore.star < score.star) {
        self.updateScore(levelId, score.score, score.star)
        var user = UserManager.getInstance().getUserRef()
        var $var20 = oldScore.star + 1,$limit21 = score.star
        for (var i = $var20; i <= $limit21; i += 1) {
            if (i <= 2) {
                user.setYellowStar(user.getYellowStar() + 1)
            } else if (i <= 3) {
                user.setOrangeStar(user.getOrangeStar() + 1)
            } else {
                // 不给加四星 所以不处理四星的状况
            }
        }
        var http = SetLevelStarHttp.new(false)
        http.load(levelId, score.star, score.score)
        return true
    }
    return false
}
UserScore.prototype.dispatchNewTopLevelTemp = function () {
    var self = this
    self.dispatchEvent(table([1, "name", UserScoreEvent.NewTopLevelTemp]))
}
UserScore.prototype.dispatchNewHideLevelSuc = function (groupId, levelId) {
    var self = this
    // body
    self.dispatchEvent(table(
        [1, "name", UserScoreEvent.NewHideSuccessLevel],
        [1, "groupId", groupId],
        [1, "levelId", levelId]
    ))
}

// 主线关卡分数超过好友，关卡超过好友用
UserScore.prototype.setLastScoreBeforeUpdate = function(score){
    var self = this
    self.lastScoreBeforeUpdate = score;
}
UserScore.prototype.setLastLevelBeforeLevelEnd = function(levelId){
    var self = this
    self.curLevel = levelId;
    self.lastLevelBeforeUpdate = UserManager.getInstance().getPassedTopLevel();
}
UserScore.prototype.getLastScoreBeforeUpdate = function(){
    var self = this
    return {score:self.lastScoreBeforeUpdate || 0, level:self.lastLevelBeforeUpdate || 0, curLevel:self.curLevel || 0};
}
